(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[884],{

/***/ "02m7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Terrace", function() { return Terrace; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Terrace = function Terrace(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 100 100"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M70.29 48.89h27.33a1.5 1.5 0 0 0 1.5-1.5v-7a1.51 1.51 0 0 0-.57-1.18L50.93 1.81h-.07a1.51 1.51 0 0 0-.28-.15l-.13-.06a1.55 1.55 0 0 0-.45-.11 1.56 1.56 0 0 0-.71.2l-.15.08L1.47 38.19a1.49 1.49 0 0 0-.59 1.19v8a1.5 1.5 0 0 0 1.5 1.5H48.5v24.35h-17a1.5 1.5 0 0 0 0 3h17v19.28H2.38a1.5 1.5 0 1 0 0 3h95.24a1.5 1.5 0 0 0 0-3H51.5V76.23h17a1.5 1.5 0 0 0 0-3h-17V48.89zm25.83-3H71.79v-5.47a1.48 1.48 0 0 0-.19-.71L54.77 8.65l41.35 32.5zM3.88 40.12L45.17 8.56 28.4 38.65a1.53 1.53 0 0 0-.19.73v6.51H3.88zm27.33-.35L50 6.1l18.79 34.7v5.09H31.21z"
  }));
};

/***/ })

}]);